/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEveStoreSelectorData } from './eve-store-selector.data';
import { IEveStoreSelectorProps } from './eve-store-selector.props.autogenerated';

export interface IEveStoreSelectorViewProps extends IEveStoreSelectorProps<IEveStoreSelectorData> {}

/**
 *
 * EveStoreSelector component
 * @extends {React.PureComponent<IEveStoreSelectorProps<IEveStoreSelectorData>>}
 */
class EveStoreSelector extends React.PureComponent<IEveStoreSelectorProps<IEveStoreSelectorData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default EveStoreSelector;
